///<reference path='../services/adFormService.ts'/>
'use strict';
// This directive is to delay the loading of all AdForm Tracking scripts
// until after AngularJS has has a change to load itself.

namespace Core {
    class AdFormController {
        script: string;
        flagName: string;

        constructor (
            private $element: JQuery,
            private $timeout: ng.ITimeoutService,
            private adFormService: Core.AdFormService
        ) {}

        $onInit() {
            if (this.adFormService.isEnabledFlag(this.flagName)) {
                this.$timeout(() => {
                    const script = `<script src="${this.script}" async></script>`;
                    this.$element.append(script);
                }, 1000);
            }
        }
    }

    angular
        .module('core')
        .directive('adForm', () => {
            return {
                restrict: 'E',
                controllerAs: 'af',
                scope: {},
                bindToController: {
                    script: '@',
                    flagName: '@'
                },
                controller: AdFormController
            };
        });
}
